import { MediaFileService } from './../../../../shared/services/media-file.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { IRegion } from './../../../../_models/account/IRegion';
import { RegionService } from './../../../../shared/services/region.service';
import { CommonService } from './../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-region-form',
  templateUrl: './region-form.component.html'
})
export class RegionFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Region';
  region: IRegion;
  regionForm: FormGroup;
  countries: IKeyValuePair[];
  id;


  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: RegionService,
    private commonService: CommonService,
    private mediaFileService: MediaFileService) {
    this.id = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createRegionForm();
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: IRegion) => {
      if (response) {
        this.region = response;
        this.title = 'Edit Region';
        this.setValueRegionForm();
      }
    });
  }

  bindDropDown() {
    this.commonService.getCountries().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.countries = response;
      }
    });
  }

  createRegionForm() {
    this.regionForm = this.fb.group({
      userId: [''],
      email: ['', [Validators.required, Validators.email]],
      name: ['', Validators.required],
      countryId: ['', Validators.required],
      code: [''],
      address: [''],
      phone_1: [''],
      phone_2: [''],
      phone_3: [''],
      email_1: [''],
      email_2: [''],
      email_3: [''],
      fax_1: [''],
      fax_2: [''],
      fax_3: [''],
      assiCommName: [''],
      assiCommSignId: ['']
    });
  }

  setValueRegionForm() {
    this.regionForm.patchValue({
      userId: this.region.userId,
      email: this.region.email,
      name: this.region.name,
      countryId: this.region.countryId,
      code: this.region.code,
      address: this.region.address,
      phone_1: this.region.phone_1,
      phone_2: this.region.phone_2,
      phone_3: this.region.phone_3,
      email_1: this.region.email_1,
      email_2: this.region.email_2,
      email_3: this.region.email_3,
      fax_1: this.region.fax_1,
      fax_2: this.region.fax_2,
      fax_3: this.region.fax_3,
      assiCommName: this.region.assiCommName,
      assiCommSignId: this.region.assiCommSignId
    });
  }

  save() {
    if (this.regionForm.valid) {
      this.loading = true;
      this.region = Object.assign({}, this.regionForm.value);
      if (this.id) {
        this.service.update(this.id, this.region).subscribe(() => {
          this.toastrService.success('region updated successful');
          this.router.navigate(['/admin/regions']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.region).subscribe(() => {
          this.toastrService.success('region created successful');
          this.router.navigate(['/admin/regions']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this region?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('region deleted successful');
      this.router.navigate(['/admin/regions']);
    });
  }


  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {

    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.regionForm.patchValue({
            mediaFileId: event.body.id
          });
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }

}
